import {
  AfterViewInit,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Subscription } from "rxjs";
import {
  ValidadeCardName,
} from "../../validators/custom.validator";
import creditCardType from "credit-card-type";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";

// Constants
import { masks } from "../../constants/masks";
import { cardBrands, cssBrands, adyenCardBrands } from "../../constants/cards";
import { SYDLEClientID } from '../../../shared/constants/one-constants';

// Models
import { PaymentConditionOption } from "../../model/payment-condition-option";
import { CustomerPaymentMethod } from "../../model/customer-payment-method";
import { PaymentMethodOption } from "../../model/payment-method-option";
import { CustomerCreditCard } from "../../model/customer-credit-card";
import { Cart } from "../../model/cart";
import { SuggestionMessage } from "../../model/sugestion-message";

// Services
import { SilentOrderService } from "../../services/silent-order.service";
import { DtmService } from "../../../services/dtm.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { Contexts } from "../../enum/contexts";
import { CartService } from "../../services/cart.service";
import { FraudnetService } from "../../services/fraudnet.service";
import { ECommerceService } from "../../../services/e-commerce.service";
import { LoadingService } from "../../services/loading.service";
import { DialogData } from 'src/app/shared/model/dialog-data';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { AdyenService } from '../../services/adyen.service';
// import '@adyen/adyen-web/dist/adyen.css';
import { AdyenCustomCardComponent } from "../adyen-custom-card/adyen-custom-card.component";
import { CreditCardData } from "../../model/credit-card-data";
import { SelfAttendanceService } from "../../services/self-attendance.service";
import { Product } from "../../model/product";
import { RegisteredCreditCardsComponent } from "../registered-credit-cards/registered-credit-cards.component";
import { Dtm, getDtm } from "../../enum/dtm";
import { Customer } from "../../model/customer";
import { CustomerService } from "../../services/customer.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "pme-payment-form",
    templateUrl: "./payment-form.component.html",
    styleUrls: ["./payment-form.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaymentFormComponent implements OnInit, AfterViewInit, DoCheck, OnChanges {
  // Defining possible contexts
  // SALE
  // SALE_WITHOUT_PAYMENT
  // RETENTION
  // UPGRADE
  // PAYMENT_CHANGE
  // ACTIVATE_AUTO_RECHARGE
  @ViewChild(AdyenCustomCardComponent) adyenCustomCardComponent: AdyenCustomCardComponent;
  @ViewChild(RegisteredCreditCardsComponent) registeredCreditCardsComponent: RegisteredCreditCardsComponent;

  @Input() context: string;

  //General variables that must be passed
  @Input() paymentOptions: Array<PaymentMethodOption>;
  @Input() buttonName = "Finalizar compra";
  @Input() termOfUse: string;
  @Input() discountBadge: string;
  @Input() discountBadgeCreditCard: string;
  @Input() redirectUrl: string;
  @Input() hideConditions: boolean;
  @Input() newPayment: boolean;
  @Input() paymentChangeProduct: Product;
  @Input() returnUrl: string;
  @Input() adyenCardError: string;
  @Input() isACreditCardError: boolean;
  //Adyen Error

  // Sale Variables
  @Input() automaticRechargeOnly: boolean = false;
  @Input() allowAutomaticRecharge: boolean = false;

  // Sale without paymentData
  @Input() campaignMessage: string;

  // Retention Variables
  @Input() retentionCreditCardCart: Cart;
  @Input() retentionBankBilletCart: Cart;
  @Input() suggestionMessage: SuggestionMessage

  // PaymentChange Variables
  @Input() paymentChangeMessage: string;
  @Input() creditCardData: CreditCardData;
  @Input() creditCardsData: CreditCardData[];

  @Input() maxLimitCreditCards: boolean;
  @Input() hasInstallment: boolean = false;
  @Input() hiddenAdobeDtm: boolean;

  @Output() formSubmitted: EventEmitter<any> = new EventEmitter<any>();
  @Output() paymentConditionSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() paymentMethodSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedOptionInstallmentEmitter = new EventEmitter();
  @Output() deleteCreditCard = new EventEmitter();

  //DtmService Variables

  // Silent Order Variables
  private silentOrderError: Subscription = null;
  private silentOrderInvalidCard: Subscription = null;
  private paymentTokenGeneration: Subscription = null;

  // Fraudnet variables
  private fraudnetToken: string;

  // Form Variables
  private _paymentFormValidationErrors: Array<any> = [];
  paymentData: CustomerPaymentMethod;

  paymentForm: UntypedFormGroup;
  automaticRechargeFormControl = new UntypedFormControl();
  paymentAdyenForm: UntypedFormGroup;
  availablePaymentOptions: Array<PaymentConditionOption>;
  productIdentifier: string;
  selectedOptionInstallmentMSG: any;
  hasPaymentBankBillet: boolean;
  hasPaymentCreditCard: boolean;
  hasPaymentPix: boolean;
  stackingOnePackageMessage: SafeHtml;
  tabOrder: Array<string> = [];
  customer: Customer;
  masks = masks;
  creditCardMask: string = masks.creditCardNumber;

  brand: string;

  selectedIndex = 0;
  submitting: boolean;
  cart: Cart;
  formsOpened: boolean = false;
  isfirstAdobeAnalyticsVerify: boolean = true;
  showAutomaticRechargeOnlyMessage: boolean = false;
  showCreditCardCard: boolean;
  showBankBilletCard: boolean;
  showCreditCardForm: boolean;
  changedCreditCard: boolean;
  disableSubmit: boolean = false;
  disableSubmitCreditCard: boolean = false;
  lastPaymentOption: string = '';
  saveCreditCard: boolean;
  defaultCard: boolean;
  // Related to enablement of submit button
  creditCardError: boolean;
  isBraspagError: boolean = false;
  braspagTryAgainErrors: boolean = false;
  isCreditCardEqual: boolean = false;
  isRepeatedCreditCardInvalid: boolean = false;
  previousCreditCardData = {
    "cardName": "",
    "cardNumber": "",
    "expirationDate": "",
    "paymentOption": "",
    "securityCode": ""
  };

  //********************************ADYEN
  checkout: any;
  customCard: any;
  component: any;
  state: any;
  adyenState: any;
  endDigits: string;
  isAdyen: boolean = false;
  adyenProductConfig: boolean = true;
  changingCreditCard: boolean;
  endPromise: boolean = false;
  productClassificationIdentifier: string;
  disableOptionConditions: Boolean = false;
  haveSavedCreditCard: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private cartService: CartService,
    private fraudnetService: FraudnetService,
    private silentOrderService: SilentOrderService,
    private sessionStorageService: SessionStorageService,
    private customerService: CustomerService,
    public dtmService: DtmService,
    private eCommerceService: ECommerceService,
    private loading: LoadingService,
    private selfAttendanceService: SelfAttendanceService,
    private AdyenService: AdyenService,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,

  ) {
    // FormGroup para os campos de cartão de crédito braspag
    this.paymentForm = this.formBuilder.group({
      cardNumber: [""],
      cardName: [""],
      expirationDate: [""],
      securityCode: [""],
      paymentOption: [""],
    });

    this.paymentAdyenForm = this.formBuilder.group({
      adyenCardName: ["", [Validators.required, ValidadeCardName]],
      adyenPaymentOption: ["", Validators.required],
    });

    this.haveSavedCreditCard = (this.creditCardsData?.length > 0);

  }

  handleDeleteCreditCard(accountPaymentDataId: string): void {
    this.deleteCreditCard.emit(accountPaymentDataId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.creditCardsData) {
      this.haveSavedCreditCard = Boolean(this.creditCardsData?.length > 0);
      this.showCreditCardForm = !this.haveSavedCreditCard;
    };
  }

  recieveSelectedOptionMSG(event) {
    this.selectedOptionInstallmentMSG = event;
    if(this.selectedOptionInstallmentMSG && this.selectedOptionInstallmentMSG.identifier) this.paymentData.paymentConditionIdentifier = this.selectedOptionInstallmentMSG.identifier;
    this.selectedOptionInstallmentEmitter.emit(this.selectedOptionInstallmentMSG);
  }
  /**
  * Função responsável por preencher o objeto paymentData com os datos encriptados da Adyen
  */
  fillPaymentDataWithEncryptedData(): void {
    this.paymentData.card.encryptedCardNumber = this.adyenCustomCardComponent.encryptedCardNumber;
    this.paymentData.card.cardNumber = "**** **** **** " + this.adyenCustomCardComponent.endDigits;
    this.paymentData.card.cardHolder = this.adyenCustomCardComponent.cardHolder;
    this.paymentData.card.encryptedCardValidityMonth = this.adyenCustomCardComponent.encryptedExpiryMonth;
    this.paymentData.card.encryptedCardValidityYear = this.adyenCustomCardComponent.encryptedExpiryYear;
    this.paymentData.card.encryptedCardSecurityCode = this.adyenCustomCardComponent.encryptedSecurityCode;
    this.paymentData.card.brand = this.adyenCustomCardComponent.brand;
    this.paymentData.paymentConditionIdentifier = this.adyenCustomCardComponent.selectedPaymentCondition;
    this.paymentData.isAdyen = true;
  }

  navigateToReturnUrl() {
    if (this.returnUrl) {
      window.location.href = this.returnUrl;
    }
  }

  /**
   * OnInit lifecycle hook - Executa quando componente está sendo iniciado
   * SilentOrderError - Subscription para quando acontece um erro de integração do silent order
   * SilentOrderInvalidCard - Subscription para quando acontece um erro ao validar dados do cartão
   */
  ngOnInit() {
    this.setSaveCreditCard(true);
    this.setDefaultCard(true);
    this.formsOpened = false;
    if (this.context === Contexts.sale || this.context === Contexts.paymentChange || this.context === Contexts.upgrade || this.context === Contexts.activateAutoRecharge || this.context === Contexts.AutoRechargePaymentChange) {
      this.haveSavedCreditCard = this.creditCardsData?.length > 0;
      this.showCreditCardForm = !this.haveSavedCreditCard;
    }

    if (this.returnUrl) {
      this.returnUrl = document.location.origin + this.returnUrl;
    }

    this.loading.addTask();
    this.selectedIndex = Number(this.sessionStorageService.getSelectedIndex());

    this.silentOrderError = this.silentOrderService.silentOrderError.subscribe(
      (error) => {
        this.showSilentOrderError([
          { Message: "Dados do Cartão de Crédito inválido." },
        ]);
        this.paymentTokenGeneration.unsubscribe();
      }
    );

    this.silentOrderInvalidCard = this.silentOrderService.silentOrderInvalidCard.subscribe(
      (error) => {
        this.showSilentOrderError(error);
        this.paymentTokenGeneration.unsubscribe();
      }
    );

    this.tabOrder = this.paymentOptions.map((paymentOption) => paymentOption.identifier).reduce((acc, curr) => {
      if (acc.indexOf(curr) < 0) {
        acc.push(curr);
      }
      return acc;
    }, []);
    this.selectAvailablePaymentMethods();


    this.cart = this.cartService.getCurrentCart();
    this.cartService.cartUpdated.subscribe(_ => this.cart = this.cartService.getCurrentCart());


    // Tabela com classificação dos produtos Adyen
    let selfAttendanceData = JSON.parse(sessionStorage.getItem('selfAttendanceData')) || null;
    const userId = this.sessionStorageService.getUserId() ? this.sessionStorageService.getUserId() : null;
    const productId = this.paymentChangeProduct?._id || this.cart?.product._id || selfAttendanceData?.selectedPackage?.product._id;
    this.productClassificationIdentifier = this.paymentChangeProduct?.classificationIdentifier || this.cart?.product.classificationIdentifier;

    this.AdyenService.getAdyenConfig(
      productId,
      this.productClassificationIdentifier,
      userId
    ).subscribe(
      (result) => {
        this.adyenProductConfig = result;
        sessionStorage.setItem('isAdyen', result + "");
        this.handleCreditCardForm();
        this.endPromise = true;
        this.loading.finishTask();
      }, () => this.loading.finishTask());
    let trustConsultationData = this.cartService.carts[0]?.trustConsultationData;
    if(trustConsultationData){
    this.sessionStorageService.setTrustConsultationData(trustConsultationData);
    }
    const trustMessage = trustConsultationData?.message;
    if (trustMessage) {
      this.stackingOnePackageMessage = this.sanitizer.bypassSecurityTrustHtml(trustMessage);
    } else {
      this.stackingOnePackageMessage = null;
    }
  }

  ngAfterViewInit(): void {
    // Subscribe to change of paymentCondition to update cart component
    this.paymentForm.valueChanges.subscribe((value: any) => {
      if (
        this.hasPaymentCreditCard &&
        this.paymentData.paymentConditionIdentifier !== value.paymentOption &&
        value.paymentOption
      ) {
        this.updateCurrentPaymentCondition(value.paymentOption);
        this.validateCardBrand();
      }
      // Verify if the credit card value has been changed
      this.isRepeatedCreditCardInvalid = this.isCreditCardEqual && this.isBraspagError;
    });

    if (this.context === Contexts.campaign) {
      this.buttonName = "Finalizar assinatura";
    }

    this.loading.finishTask();
  }


  ngDoCheck() {
    if (
      this.context === Contexts.upgrade ||
      this.context === Contexts.retention ||
      this.context === Contexts.sale ||
      this.context === Contexts.activateAutoRecharge ||
      this.context === Contexts.paymentChange ||
      this.context === Contexts.AutoRechargePaymentChange
    ) {

      if (this.creditCardsData) {
        if (!this.paymentData) {
          this.paymentData = new CustomerPaymentMethod("CREDIT_CARD");
          this.paymentData.sameCard = true;
        }

        // Possui cartao de credito ja existente
        if (!this.changedCreditCard) {
          // this.paymentData.card = new CustomerCreditCard(this.creditCardsData[0]);
          this.paymentData.sameCard = true;
          this.showCreditCardCard = true;
          this.showCreditCardForm = false;
        } else {
          //Descomentar: novos cartões devem ser sempre Adyen
          //this.isAdyen = true;
          this.showCreditCardCard = false;
          // this.showCreditCardForm = true; //ajuste pontual para ser constante o showCreditCard como true, caso der erro descomentar
        }

        this.brand = this.paymentData.getCreditCardIcon();
      }

      if (this.retentionCreditCardCart) {
        this.showCreditCardForm = false;
        this.showCreditCardCard = true;
      }

      if (this.retentionBankBilletCart) {
        this.showBankBilletCard = true;
      }

      // if (this.paymentData.identifier === 'PIX') {
      //   this.buttonName = "Gerar QR Code";
      // } else {
      this.buttonName = "Finalizar compra";
      // }
    }
  }
  openErrorDialog(dialogData) {
    const data = DialogData.fromPreset(dialogData);
    const content = data.errorMessage;
    const errorDetail = data.errorDetail;

    this.dialog.open(DialogAlertComponent, {
      disableClose: dialogData === 'checksum' ? true : false,
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    // Analytics
    this.dtmService.customErrorLoaded(['error'], {
      errorDetail: errorDetail,
      errorMessage: content,
    });
  }
  onButtonClick() {
    let productDisconnectSaleData = JSON.parse(this.sessionStorageService.getCustomData('disconnectedSaleProduct'));
    if (productDisconnectSaleData !== null) {
      const customer = this.sessionStorageService.getCustomer();
      const businessId = customer.provisioningParameter.businessId;
      const userId = customer.provisioningParameter.userId;
      let productData = JSON.parse(this.sessionStorageService.getCustomData('disconnectedSaleProduct'));
      const productFamilyIdentifier = productData.classificationIdentifier;
      this.productIdentifier = this.sessionStorageService.getCustomData('productIdentifier');
      let cartProductData = JSON.parse(this.sessionStorageService.getCustomData('cart'));
      this.dtmService.userLoaded({
        userId: userId,
        businessId: businessId,
        clientId: SYDLEClientID
      });

      this.dtmService.pageLoaded(Dtm.PagamentoCompraDeslogada, true, getDtm(Dtm.PagamentoCompraDeslogada, productFamilyIdentifier));
      this.dtmService.productsLoaded([{
        identifier: this.productIdentifier,
        classificationName: productDisconnectSaleData.productName,
        quantity: 1,
        totalValue: Number(cartProductData.totalValue).toFixed(2).replace('.', ','),
      },]);
      let checkoutDeslogadoTag = "CheckoutCompraDeslogada:CadastroDeslogado:";
      this.dtmService.customClickEvent(checkoutDeslogadoTag + "FinalizarCompra");
    }
  }
  onAdyenSubmit() {
    this.clearValidationErrors();

    if (
      this.context === Contexts.sale ||
      this.context === Contexts.paymentChange ||
      this.context === Contexts.activateAutoRecharge ||
      this.context === Contexts.AutoRechargePaymentChange ||
      this.context === Contexts.retention
    ) {
      // Gera um novo token fraudnet para a venda
      this.fraudnetService.generateNewFraudnetToken();
      this.fraudnetService.generatedFraudnetToken.subscribe((generatedToken) => {
        this.paymentData.fraudnetData.token = generatedToken;
      });

      // Obtem o IP do cliente para enviar ao Fraudnet
      this.fraudnetService.getIP().subscribe(result => {
        if (result && result.ip) {
          this.paymentData.fraudnetData.ip = result.ip;
        }
      });

      // Envia o BIN do cartao para o Fraudnet
      if (this.adyenCustomCardComponent && this.adyenCustomCardComponent.binValue) {
        this.paymentData.fraudnetData.bin = this.adyenCustomCardComponent.binValue;
      }

      if (this.paymentData.identifier === "CREDIT_CARD") {

        if (this.paymentData.sameCard && this.registeredCreditCardsComponent) {
          const creditCardSelected = this.creditCardsData.find(card => card.accountPaymentDataId === this.registeredCreditCardsComponent.selectedRadioButton);
          this.paymentData.card = new CustomerCreditCard(creditCardSelected);
          this.paymentData.accountPaymentDataId = this.registeredCreditCardsComponent?.selectedRadioButton;
        }
        this.paymentData.defaultCard = this.paymentData.sameCard ? this.registeredCreditCardsComponent?.defaultCard : this.defaultCard;
        // se caso o cartão cadastrado for braspag
        if (!this.isAdyen && !this.showCreditCardForm) {
          this.onSubmit();
          return;
        }

        this.paymentData.isAdyen = true;
        if (!this.paymentData.sameCard) {
          this.fillPaymentDataWithEncryptedData();
        }

        // throw "TESTE";
        if (this.adyenCustomCardComponent && this.adyenCustomCardComponent.isValid) {
          this.submitting = true;
          this.disableFields("all");
          this.paymentData.saveCard = this.saveCreditCard;
          this.formSubmitted.emit(this.paymentData);

        } else if (
          this.context === Contexts.sale ||
          this.context === Contexts.activateAutoRecharge ||
          this.context === Contexts.AutoRechargePaymentChange ||
          this.context === Contexts.paymentChange
        ) {

          this.paymentData.saveCard = this.saveCreditCard;
          this.submitting = true;
          this.disableFields("all");
          this.formSubmitted.emit(this.paymentData);
        }
      } else if (this.paymentData.identifier === "BANK_BILLET") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      } else if (this.paymentData.identifier === "PIX") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      }

    } else if (this.context === Contexts.upgrade) {
      if (this.paymentData.identifier === "CREDIT_CARD") {


        if (this.paymentData.sameCard && this.registeredCreditCardsComponent) {
          const creditCardSelected = this.creditCardsData.find(card => card.accountPaymentDataId === this.registeredCreditCardsComponent.selectedRadioButton);
          this.paymentData.card = new CustomerCreditCard(creditCardSelected);
          this.paymentData.accountPaymentDataId = this.registeredCreditCardsComponent?.selectedRadioButton;
        }
        this.paymentData.defaultCard = this.paymentData.sameCard ? this.registeredCreditCardsComponent?.defaultCard : this.defaultCard;
        // se caso o cartão cadastrado for braspag
        if (!this.isAdyen && !this.showCreditCardForm) {
          this.onSubmit();
          return;
        }

        this.paymentData.isAdyen = true;
        // Shows loading spinner
        this.submitting = true;
        this.disableFields("all");
        if (this.creditCardData || this.paymentData.card) {
          if (this.paymentData.sameCard) {
            this.paymentData.sameCard = true;
          } else {
            this.fillPaymentDataWithEncryptedData();
          }

          this.paymentData.saveCard = this.saveCreditCard;

          this.formSubmitted.emit(this.paymentData);
        }
      } else if (this.paymentData.identifier === "BANK_BILLET") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      } else if (this.paymentData.identifier === "PIX") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      }
    } else if (this.context === Contexts.campaign) {
      this.paymentData.isAdyen = true;
      this.submitting = true;
      this.formSubmitted.emit(new CustomerPaymentMethod("BANK_BILLET"));
    }
    if (this.registeredCreditCardsComponent) {
      this.registeredCreditCardsComponent.checkDisplaySuggestionMessage();
    }
  }

  /**
   * onSubmit form - Quando finalizar pagamento é pressionado
   * Valida se o formulário está correto, caso sim, realiza a integração
   * com o silent order e envia um event emitter para o componente pai
   * que deve ser responsável por realizar o checkout.
   */
  onSubmit() {
    this.isBraspagError = false;
    this.clearValidationErrors();

    if (
      this.context === Contexts.sale ||
      this.context === Contexts.paymentChange ||
      this.context === Contexts.activateAutoRecharge ||
      this.context === Contexts.AutoRechargePaymentChange ||
      this.context === Contexts.retention
    ) {
      //não é mais necessário ja que o adyen faz isso
      // // Gera um novo token fraudnet para a venda
      // this.fraudnetService.generateNewFraudnetToken();
      // this.fraudnetService.generatedFraudnetToken.subscribe((generatedToken) => {
      //   this.paymentData.fraudnetData.token = generatedToken;
      // });

      // // Obtem o IP do cliente para enviar ao Fraudnet
      // this.fraudnetService.getIP().subscribe(result => {
      //   if (result && result.ip) {
      //     this.paymentData.fraudnetData.ip = result.ip;
      //   }
      // });

      // // Envia o BIN do cartao para o Fraudnet
      // // O flag "sameCard" nao pode ser true porque senao nao temos acesso ao BIN do cartao
      // if (this.paymentData && this.paymentData.card && this.paymentData.card.cardNumber && !this.paymentData.sameCard) {
      //   this.paymentData.fraudnetData.bin = this.paymentData.card.cardNumber.replace(" ", "").substring(0, 6);
      // }

      if (this.paymentData.identifier === "CREDIT_CARD") {
        // usado pra comparar se houve alteração nos dados do cartão e dar enable no botão de finalizar pagamento
        this.previousCreditCardData = this.paymentForm.value;
        // não há necessidade de validar já que o cartao ja esta salvo
        if (false) {
          this.submitting = true;
          this.disableFields("all");
          if (this.paymentData.card) {
            this.paymentTokenGeneration = this.silentOrderService.paymentTokenGenerated.subscribe(
              () => {
                // PaymentToken Generated
                this.paymentTokenGeneration.unsubscribe();
                this.formSubmitted.emit(this.paymentData);
              }
            );

            // Generates the paymentToken
            this.silentOrderService.generatePaymentToken(this.paymentData.card);
          }

        } else if (
          this.context === Contexts.sale ||
          this.context === Contexts.activateAutoRecharge
        ) {
          this.submitting = true;
          this.disableFields("all");
          if (this.creditCardData) {
            // Se utilizou o mesmo cartao, nao precisa passar pelo fluxo de geracao do paymentToken
            if (this.paymentData.sameCard) {
              this.formSubmitted.emit(this.paymentData);
            } else {
              this.paymentTokenGeneration = this.silentOrderService.paymentTokenGenerated.subscribe(
                () => {
                  // PaymentToken Generated
                  this.paymentTokenGeneration.unsubscribe();
                  this.formSubmitted.emit(this.paymentData);
                }
              );

              // Generates the paymentToken
              this.silentOrderService.generatePaymentToken(
                this.paymentData.card
              );
            }
          }
        }
      } else if (this.paymentData.identifier === "BANK_BILLET") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      } else if (this.paymentData.identifier === "PIX") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      }
    } else if (this.context === Contexts.upgrade) {
      if (this.paymentData.identifier === "CREDIT_CARD") {
        // Shows loading spinner
        this.submitting = true;
        this.disableFields("all");
        if (this.creditCardData) {
          // Se utilizou o mesmo cartao, nao precisa passar pelo fluxo de geracao do paymentToken
          if (this.paymentData.sameCard) {
            this.paymentData.sameCard = true;
            this.formSubmitted.emit(this.paymentData);
          } else {
            this.paymentTokenGeneration = this.silentOrderService.paymentTokenGenerated.subscribe(
              () => {
                // PaymentToken Generated
                this.paymentTokenGeneration.unsubscribe();
                this.formSubmitted.emit(this.paymentData);
              }
            );

            // Generates the paymentToken
            this.silentOrderService.generatePaymentToken(this.paymentData.card);
          }
        } else if (this.paymentData.card) {
          this.paymentTokenGeneration = this.silentOrderService.paymentTokenGenerated.subscribe(
            () => {
              // PaymentToken Generated
              this.paymentTokenGeneration.unsubscribe();
              this.formSubmitted.emit(this.paymentData);
            }
          );

          // Generates the paymentToken
          this.silentOrderService.generatePaymentToken(this.paymentData.card);
        }
      } else if (this.paymentData.identifier === "BANK_BILLET") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      } else if (this.paymentData.identifier === "PIX") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      }
    } else if (this.context === Contexts.campaign) {
      this.submitting = true;
      this.formSubmitted.emit(new CustomerPaymentMethod("BANK_BILLET"));
    } else if (this.context === Contexts.retention) {
      if (this.paymentData.identifier === "CREDIT_CARD") {
        if (this.showCreditCardCard && this.paymentData.card) {
          this.submitting = true;
          this.formSubmitted.emit(this.paymentData);
        }
      } else if (this.paymentData.identifier === "BANK_BILLET") {
        this.submitting = true;
        this.formSubmitted.emit(this.paymentData);
      }
    }
    this.registeredCreditCardsComponent.checkDisplaySuggestionMessage();
  }

  handleUpdatePaymentConditionIdentifier(paymentConditionIdentifier) {
    this.paymentData.paymentConditionIdentifier = paymentConditionIdentifier;

  }

  handlePaymentConditionInstallment(paymentCondition){
    this.selectedOptionInstallmentEmitter.emit(paymentCondition);
  }

  /**
   * Método de validação da bandeira de cartão de crédito
   * Executado a cada alteração no formulário, caso uma bandeira seja encontrada, retorna como objeto TextMask
   */
  validateCardBrand(): any {
    if (
      this.paymentData &&
      this.paymentData.card &&
      this.paymentData.card.cardNumber &&
      this.paymentData.card.cardNumber.length >= 2
    ) {
      let brand = creditCardType(this.paymentData.card.cardNumber);
      if (brand && brand.length) {
        brand = brand[0];
        if (
          masks[brand.type] &&
          cardBrands[brand.type] !== this.paymentData.card.brand
        ) {
          this.brand = cssBrands[cardBrands[brand.type]];
          this.paymentData.card.brand = cardBrands[brand.type];
          this.creditCardMask = masks[brand.type];
        }
      }
    }

    return this.creditCardMask;
  }

  selectAvailablePaymentMethods() {
    if (
      this.campaignMessage &&
      this.hasPaymentBankBillet === undefined &&
      this.hasPaymentCreditCard === undefined
    ) {
      this.hasPaymentCreditCard = false;
      this.hasPaymentBankBillet = false;
      this.selectedIndex = 0;
    } else {
      this.paymentOptions.forEach((paymentOption) => {
        switch (paymentOption.identifier) {
          case 'BANK_BILLET':
            this.hasPaymentBankBillet = true;
            break;
          case 'PIX':
            this.hasPaymentPix = true;
            break;
          case 'CREDIT_CARD':
            this.hasPaymentCreditCard = true;

            const currPaymentOps = JSON.stringify(this.availablePaymentOptions);
            const incPaymentOps = JSON.stringify(paymentOption.paymentConditionOptions);
            if (currPaymentOps !== incPaymentOps) {
              this.availablePaymentOptions = paymentOption.paymentConditionOptions;
            }
            break;
        }
        // if (paymentOption.identifier === 'BANK_BILLET') {
        //   if (this.paymentOptions.length === 1) {
        //     this.hasPaymentBankBillet = true;
        //     this.hasPaymentCreditCard = false;
        //   } else {
        //     this.hasPaymentBankBillet = true;
        //   }
        // } else if (paymentOption.identifier === 'PIX') {
        //   this.hasPaymentPix = true;
        // } else if (paymentOption.identifier === 'CREDIT_CARD') {
        //   this.hasPaymentCreditCard = true;

        // const currPaymentOps = JSON.stringify(this.availablePaymentOptions);
        // const incPaymentOps = JSON.stringify(paymentOption.paymentConditionOptions);
        // if (currPaymentOps !== incPaymentOps) {
        //   this.availablePaymentOptions = paymentOption.paymentConditionOptions;
        // }
        // }
      });
    }
    this.storePaymentMethod(this.selectedIndex);

    if (this.paymentData && this.paymentData.paymentConditionIdentifier) {
      this.updateCurrentPaymentCondition(
        this.paymentData.paymentConditionIdentifier
      );
    }

  }

  // verifySelectedTab(){
  //   if(this.sessionStorageService.getPaymentMethodIdentifier() === "BANK_BILLET") {
  //     this.adyenCustomCardComponent.unmount();
  //   } else if(this.sessionStorageService.getPaymentMethodIdentifier() === "CREDIT_CARD") {
  //     this.adyenCustomCardComponent.mount();
  //   }
  // }

  storePaymentMethodByIdentifier(paymentMethodIdentifier: string) {
    let paymentIndex = this.tabOrder.indexOf(paymentMethodIdentifier);
    paymentIndex = paymentIndex >= 0 ? paymentIndex : 0;
    this.storePaymentMethod(paymentIndex);
  }

  storePaymentMethod(identifier: number) {
    let paymentMethodIdentifier;
    paymentMethodIdentifier = this.tabOrder[identifier];
    this.selectedIndex = identifier;
    // if (this.paymentOptions && this.paymentOptions.length > 1) {
    //   if(identifier === 0 && this.paymentOptions.find(el => el.identifier === "CREDIT_CARD")) paymentMethodIdentifier = "CREDIT_CARD";
    //   if(identifier === 1 && this.paymentOptions.find(el => el.identifier === "BANK_BILLET")) paymentMethodIdentifier = "BANK_BILLET";

    //   if((identifier === 1 && !this.paymentOptions.find(el => el.identifier === "BANK_BILLET") && this.paymentOptions.find(el => el.identifier === "PIX")) || ((identifier === 2 && this.paymentOptions.find(el => el.identifier === "PIX")))) paymentMethodIdentifier = "PIX";

    // } else {
    //   paymentMethodIdentifier = this.paymentOptions[0].identifier;
    // }
    this.showCreditCardForm = paymentMethodIdentifier === 'CREDIT_CARD' ? true : false;

    this.sessionStorageService.setSelectedIndex(identifier);
    this.sessionStorageService.setPaymentMethodIdentifier(
      paymentMethodIdentifier
    );

    // if (!this.hiddenAdobeDtm) {
    //   if (!this.isfirstAdobeAnalyticsVerify) {
    //     this.dtmService.customClickEvent("Troca de forma de pagamento", paymentMethodIdentifier);
    //   } else {
    //     this.isfirstAdobeAnalyticsVerify = false;
    //   }

    // }
    if (!this.paymentData) {
      this.paymentData = new CustomerPaymentMethod(paymentMethodIdentifier);
      // Selecionando o maior parcelamento possível
      if (paymentMethodIdentifier === "CREDIT_CARD") {

        this.paymentOptions.forEach((paymentOption) => {
          if (paymentOption.identifier === paymentMethodIdentifier) {

            if (paymentOption.paymentConditionOptions.length === 1) {
              this.paymentData.paymentConditionIdentifier = paymentOption.paymentConditionOptions[0].identifier;
              this.disableOptionConditions = true;
            }
          }
        });
      }
    } else {
      this.paymentData.identifier = paymentMethodIdentifier;
      const chosenPaymentMethod = this.paymentOptions.filter(
        (pOption) => pOption.identifier === paymentMethodIdentifier
      );
      if (
        chosenPaymentMethod &&
        chosenPaymentMethod.length > 0 &&
        chosenPaymentMethod[0].identifier === "CREDIT_CARD"
      ) {
        chosenPaymentMethod.forEach((pm) => {
          if (
            pm.paymentConditionOptions &&
            pm.paymentConditionOptions.length > 0
          ) {
            if (pm.paymentConditionOptions.length === 1) {
              this.paymentData.paymentConditionIdentifier = pm.paymentConditionOptions[0].identifier;
              this.disableOptionConditions = true;
            }
            this.cartService.paymentOptionChanged.next(
              this.paymentData.paymentConditionIdentifier
            );
            this.paymentConditionSelected.emit(
              this.paymentData.paymentConditionIdentifier
            );
            // this.paymentData.paymentConditionIdentifier = pm.paymentConditionOptions.map(pmo => pmo.identifier)[0];
          }
        });
      }
    }

    this.clearValidationErrors();
    this.isBraspagError = false; // ao zerar o vetor de erros de validação liberar o botão de finalizar pagamento
    this.paymentMethodSelected.emit(this.paymentData.identifier);

    // Colocar validador de obrigatóriedade dinamicamente
    if (
      this.paymentData.identifier === "CREDIT_CARD" &&
      this.hideConditions !== true
    ) {
      this.paymentForm.controls.paymentOption.setValidators(
        Validators.required
      );
    }
  }

  updateCurrentPaymentCondition(paymentCondition: string) {
    this.lastPaymentOption = paymentCondition;

    if (this.paymentData.identifier === "BANK_BILLET") {
      this.paymentData.paymentConditionIdentifier = "";
    } else {
      if (
        this.paymentForm.controls.paymentOption.value === null ||
        this.paymentForm.controls.paymentOption.value === undefined
      ) {
        this.paymentOptions.forEach((paymentOption) => {
          if (paymentOption.identifier === this.paymentData.identifier) {
            this.paymentData.paymentConditionIdentifier = this.lastPaymentOption ?? paymentOption.paymentConditionOptions[0].identifier;
          }
        });
        this.paymentForm.controls.paymentOption.setValue(
          this.paymentData.paymentConditionIdentifier
        );
      } else {
        this.paymentData.paymentConditionIdentifier = paymentCondition;
      }
      this.paymentConditionSelected.emit(paymentCondition);
      // Atualiza parcelamento no carrinho
      this.cartService.paymentOptionChanged.next(paymentCondition);
    }
  }

  handleCartUpdated(paymentOptions: Array<PaymentMethodOption>) {
    this.paymentOptions = paymentOptions;
    this.isfirstAdobeAnalyticsVerify = true;
    this.selectAvailablePaymentMethods();
  }

  /**
   * Lidando com erros do form de cartão de crédito
   */
  getPaymentErrors(): { [key: string]: any } {
    const map: { [key: string]: string } = {};
    // Validando requireds
    Object.keys(this.paymentForm.controls).forEach((key) => {
      const keyName = key.toString();
      map[keyName] = this.paymentForm.controls[keyName].hasError("required")
        ? "Campo obrigatório"
        : null;
    });
    // // Validacoes específicas
    map.cardNumber =
      map.cardNumber ||
      this.paymentForm.controls.cardNumber.getError("cardNumberError");
    map.cardName =
      map.cardName ||
      this.paymentForm.controls.cardName.getError("cardNameError");
    map.expirationDate =
      map.expirationDate ||
      this.paymentForm.controls.expirationDate.getError("expirationDateError");
    map.securityCode =
      map.securityCode ||
      this.paymentForm.controls.securityCode.getError("securityCoderror");
    map.paymentOption =
      map.paymentOption ||
      this.paymentForm.controls.paymentOption.getError("paymentOptionError");

    return map;
  }

  /**
   * Desativa campos do formulário
   * @param fieldName - campo que deve ser desativado, em caso de 'all', desativa todos
   */
  disableFields(fieldName: string) {
    if (this.paymentData.sameCard) return;

    if (fieldName === "all") {
      if (this.isAdyen) {
        const customAdyenDiv = document.getElementById("customCard-container");
        if (customAdyenDiv) customAdyenDiv.style.pointerEvents = 'none';
      } else {
        Object.keys(this.paymentForm.controls).forEach((key) => {
          const keyName = key.toString();
          this.paymentForm.controls[keyName].disable();
        });
      }
    } else if (this.paymentForm.controls[fieldName]) {
      this.paymentForm.controls[fieldName].disable();
    }
  }
  /**
   * Ativa campos do formulário
   * @param fieldName - campo que deve ser ativado, em caso de 'all', ativa todos
   */
  enableFields(fieldName: string) {
    if (fieldName === "all") {
      if (this.isAdyen) {
        const customAdyenDiv = document.getElementById("customCard-container");
        if (customAdyenDiv) customAdyenDiv.style.pointerEvents = 'auto';
      } else {
        Object.keys(this.paymentForm.controls).forEach((key) => {
          const keyName = key.toString();
          this.paymentForm.controls[keyName].enable();
        });
      }
    } else {
      if (this.paymentForm.controls[fieldName]) {
        this.paymentForm.controls[fieldName].enable();
      }
    }
  }

  /**
   * Lidando com erros de integração com o silent order post
   * @param errors
   */

  showSilentOrderError(errors: Array<any>) {

    errors.forEach((err) => this.addValidationError(err.Message));

    this.dtmService.customErrorLoaded(["error"], {
      errorDetail:
        "silentOrder:" + JSON.stringify(errors.map((err) => err.Message)),
      errorMessage: this.paymentFormValidationErrors.toString(),
    });

    this.submitting = false;
    this.enableFields("all");
  }

  changeCreditCard() {
    this.formsOpened = true;
    this.creditCardData = null;
    this.handleCreditCardForm();
    this.disableSubmitCreditCard = false;
    this.paymentData.card = new CustomerCreditCard();
    this.paymentData.sameCard = false;
    this.showCreditCardCard = false;
    this.showCreditCardForm = true;
    this.changedCreditCard = true;
    this.isBraspagError = false;
    this.setSaveCreditCard(true);
    this.setDefaultCard(true);
    this.clearValidationErrors();
  }

  handleRegisteredCreditCards() {
    this.formsOpened = false;
    this.disableSubmitCreditCard = false;
    this.paymentData.paymentConditionIdentifier = '';
    this.paymentData.sameCard = true;
    this.isACreditCardError = false;
    this.showCreditCardCard = true;
    this.showCreditCardForm = false;
    this.changedCreditCard = false;
    this.clearValidationErrors();
    this.dtmService.customClickEvent("Voltar para tela de cartões salvos", "Saindo de 'Adicionar novo cartão de crédito'");
  }

  onAutomaticRechargeClick(event, autoToggle = false) {
    this.allowAutomaticRecharge = event.checked;
    // Se o produto so permite venda com recarga automatica
    if (this.cart && this.cart.product && this.cart.product.automaticRechargeOnly) {
      this.allowAutomaticRecharge = true;
      this.showAutomaticRechargeOnlyMessage = true;
      this.dtmService.customClickEvent("Recarga Garantida", "Tentativa de desativação, porém produto só é vendido com recarga ativa.");
      // Da um timeout de 400ms para que o toggle seja reativado automaticamente
      setTimeout(() => {
        this.automaticRechargeFormControl.setValue(true);
      }, 400);
    } else {
      // emite um evento para chamar o método do cart-component
      this.cartService.allowAutomaticRechargeChange.next({ event, autoToggle });
    }
  }

  setDefaultCard(defalut: boolean) {
    this.defaultCard = defalut;
    // this.handleSaveCardChange();
  }

  handleDefaultCard() {
    this.dtmService.customClickEvent("Definir como cartão padrão", (this.defaultCard ? "Ativação" : "Desativação") + " do Definir como cartão padrão");
  }

  private setSaveCreditCard(v: boolean) {
    this.saveCreditCard = v;
    this.sessionStorageService.setAdditionalData({
      byParameter: {
        saveCreditCard: this.saveCreditCard
      }
    });
  }

  handleSaveCardChange() {
    !this.saveCreditCard ? this.setDefaultCard(false) : null;
    this.dtmService.customClickEvent("Lembrar cartão nas próximas compras", (this.saveCreditCard ? "Ativação" : "Desativação") + " do lembrar cartão de crédito.");
  }

  handleCreditCardForm() {
    if (this.creditCardData && !this.creditCardData.isAdyen) return;

    // Verificação necessária para garantir que as configurações de adyen
    // já estão disponíveis
    this.isAdyen = this.adyenProductConfig !== false

    if (this.creditCardData && !this.isAdyen) this.changeCreditCard();
  }

  public addValidationError(err, paymentMethod = this.selectedIndex) {
    if (!this._paymentFormValidationErrors[paymentMethod]) this._paymentFormValidationErrors[paymentMethod] = [];
    this._paymentFormValidationErrors[paymentMethod].push(err);

  }

  public clearValidationErrors() {
    // this.adyenCardError = null;
    // this.suggestionMessage = null;
    // this.isACreditCardError = false;
    this._paymentFormValidationErrors = [];
  }

  public get paymentFormValidationErrors(): Array<any> {
    return this._paymentFormValidationErrors[this.selectedIndex];
  }

  automaticRechargeValueFormat() {
    let automaticRechargeValue = this.cart.product.automaticRecharge;
    return Number.isInteger(automaticRechargeValue) ? automaticRechargeValue : automaticRechargeValue.toFixed(2).replace('.', ',');
  }

}
